const getPayload = (message, data) => {
  const payload = { source: 'pov-wrapper', event: message };

  if (data) {
    payload.data = data;
  }

  return payload;
};

const post = (message, data) => {
  window.parent.postMessage(getPayload(message, data), '*');
};

// Answers the asking window directly. The wrapped envelope is required: Angular only
// parses the shape eventListenerService.emit produces, not a raw pov-wrapper payload.
const reply = (message, data, targetWindow, targetOrigin = '*') => {
  if (!targetWindow) {
    post(message, data);
    return;
  }
  targetWindow.postMessage({ event: 'on-message', payload: getPayload(message, data) }, targetOrigin);
};

/*
 * Sends a message to the window that opened the current window tab.
 * This function is used when the current window is a child window and needs to communicate back to its opener tab.
 * For example, it used when purchasing a paid app via the app market using PayGateProxy.
 */
const postOpener = (message, data) => {
  window.opener.postMessage(getPayload(message, data), '*');
};

export default {
  post,
  reply,
  postOpener,
};
